(() => {
    const fixedBodyClass = "perfil-search-is-fixed";
    const hostId = "perfil-search-fixed-host";
    const scrollBoxSelector = [
        "[data-scroll-passthrough]",
        ".sobre-palestrante-text",
        ".palestras-site-cards",
        ".temas-video-grid",
    ].join(", ");
    let ticking = false;
    let lastSearchOffset = "";
    let disposeSearch = () => {};

    function bindInlineSearch(form) {
        const input = form.querySelector("[name='termo']");
        const panel = form.querySelector("[data-perfil-results]");
        const list = form.querySelector("[data-perfil-list]");
        const status = form.querySelector("[data-perfil-status]");
        const more = form.querySelector("[data-perfil-more]");
        if (!input || !panel || !list || !status || !more) return;
        const events = new AbortController();
        let request;
        let timer;
        let page = 1;
        let loadedTerm = "";
        let composing = false;

        const position = () => {
            const viewport = window.visualViewport;
            const bottom = viewport ? viewport.height + viewport.offsetTop : window.innerHeight;
            panel.style.setProperty("--perfil-results-height", `${Math.max(0, bottom - form.getBoundingClientRect().bottom - 20)}px`);
        };
        const show = () => {
            position();
            panel.hidden = false;
            input.setAttribute("aria-expanded", "true");
        };
        const cancel = () => {
            window.clearTimeout(timer);
            request?.abort();
            request = null;
            more.disabled = false;
            list.removeAttribute("aria-busy");
        };
        const close = () => {
            cancel();
            panel.hidden = true;
            input.setAttribute("aria-expanded", "false");
        };
        const reset = () => {
            list.replaceChildren();
            more.hidden = true;
            loadedTerm = "";
            page = 1;
        };

        async function search(append = false) {
            cancel();
            const term = input.value.trim();
            if (!append) reset();
            show();
            if (!term) {
                status.textContent = form.dataset.searchHint;
                return;
            }
            const controller = new AbortController();
            request = controller;
            const nextPage = append ? page + 1 : 1;
            const url = new URL(form.action, window.location.origin);
            url.search = "";
            url.searchParams.set("termo", term);
            url.searchParams.set("fragment", "cards");
            url.searchParams.set("pagina", String(nextPage));
            status.textContent = form.dataset.searchLoading;
            list.setAttribute("aria-busy", "true");
            more.disabled = true;
            try {
                const response = await fetch(url, {
                    headers: { "X-Requested-With": "XMLHttpRequest" },
                    signal: controller.signal,
                });
                if (!response.ok) throw new Error("perfil-search-failed");
                const template = document.createElement("template");
                template.innerHTML = await response.text();
                if (controller.signal.aborted || !form.isConnected || input.value.trim() !== term) return;
                const meta = template.content.querySelector("[data-catalog-append]");
                if (!meta) throw new Error("perfil-search-invalid-fragment");
                const cards = [...template.content.querySelectorAll(".card-palestrante-site")];
                cards.forEach((card) => {
                    const source = card.querySelector(".card-palestrante-site-media");
                    const name = card.querySelector("h3")?.textContent.trim();
                    if (!source || !name) return;
                    const link = document.createElement("a");
                    link.href = source.getAttribute("href");
                    link.className = "perfil-search-result";
                    const photo = source.querySelector("img");
                    if (photo) {
                        const image = photo.cloneNode();
                        image.alt = "";
                        image.loading = "lazy";
                        link.appendChild(image);
                    }
                    const copy = document.createElement("span");
                    const title = document.createElement("strong");
                    title.textContent = name;
                    copy.appendChild(title);
                    const specialty = card.querySelector(".card-palestrante-site-overlay-specialty, .card-palestrante-site-specialty")?.textContent.trim();
                    if (specialty) {
                        const detail = document.createElement("small");
                        detail.textContent = specialty;
                        copy.appendChild(detail);
                    }
                    link.appendChild(copy);
                    const item = document.createElement("li");
                    item.appendChild(link);
                    list.appendChild(item);
                });
                page = nextPage;
                loadedTerm = term;
                status.textContent = list.children.length ? form.dataset.searchFound : form.dataset.searchEmpty;
                more.hidden = meta.dataset.hasMore !== "1";
            } catch (error) {
                if (controller.signal.aborted || !form.isConnected) return;
                status.textContent = form.dataset.searchError;
            } finally {
                if (request === controller) {
                    request = null;
                    more.disabled = false;
                    list.removeAttribute("aria-busy");
                }
            }
        }

        const onInput = () => {
            cancel();
            reset();
            if (composing || input.value.trim().length < 2) {
                close();
                return;
            }
            show();
            status.textContent = form.dataset.searchLoading;
            timer = window.setTimeout(() => search(), 300);
        };
        form.addEventListener("submit", (event) => {
            event.preventDefault();
            // Keep the shared form handler from forcing a native catalog navigation.
            event.stopPropagation();
            search();
        }, { signal: events.signal });
        input.addEventListener("input", onInput, { signal: events.signal });
        input.addEventListener("compositionstart", () => { composing = true; cancel(); }, { signal: events.signal });
        input.addEventListener("compositionend", () => { composing = false; onInput(); }, { signal: events.signal });
        input.addEventListener("focus", () => {
            if (loadedTerm && loadedTerm === input.value.trim()) show();
        }, { signal: events.signal });
        form.querySelector("[data-perfil-close]").addEventListener("click", () => {
            input.focus({ preventScroll: true });
            close();
        }, { signal: events.signal });
        more.addEventListener("click", () => search(true), { signal: events.signal });
        form.addEventListener("keydown", (event) => {
            if (event.isComposing) return;
            if (event.key === "Escape") {
                input.focus({ preventScroll: true });
                close();
                event.preventDefault();
            }
            if (panel.hidden || !["ArrowDown", "ArrowUp"].includes(event.key)) return;
            const links = [...list.querySelectorAll("a")];
            const index = links.indexOf(document.activeElement);
            if (document.activeElement !== input && index < 0) return;
            event.preventDefault();
            if (event.key === "ArrowUp" && index <= 0) input.focus({ preventScroll: true });
            else links[Math.min(links.length - 1, index + (event.key === "ArrowDown" ? 1 : -1))]?.focus();
        }, { signal: events.signal });
        document.addEventListener("pointerdown", (event) => {
            if (!form.contains(event.target)) close();
        }, { signal: events.signal });
        document.addEventListener("focusin", (event) => {
            if (!form.contains(event.target)) close();
        }, { signal: events.signal });
        window.addEventListener("scroll", position, { passive: true, signal: events.signal });
        window.addEventListener("resize", position, { signal: events.signal });
        window.visualViewport?.addEventListener("resize", position, { signal: events.signal });
        disposeSearch = () => { cancel(); events.abort(); };
    }

    function headerHeight() {
        const header = document.getElementById("site-header");
        return header?.offsetHeight
            || parseFloat(getComputedStyle(document.documentElement).getPropertyValue("--site-header-height"))
            || 72;
    }

    function measureSearchOffset(form) {
        return Math.max(form?.offsetHeight || 0, 48) + 16;
    }

    function setSearchOffset(form) {
        const next = `${measureSearchOffset(form)}px`;
        if (next === lastSearchOffset) {
            return;
        }
        lastSearchOffset = next;
        document.documentElement.style.setProperty("--perfil-search-offset", next);
    }

    function fixedHost() {
        let host = document.getElementById(hostId);
        if (!host) {
            host = document.createElement("div");
            host.id = hostId;
            host.className = "perfil-search-fixed-host";
            document.body.appendChild(host);
        }
        return host;
    }

    function parkForm(shell, form) {
        if (form.parentElement === shell) {
            return;
        }
        shell.appendChild(form);
    }

    function liftForm(form) {
        const host = fixedHost();
        if (form.parentElement !== host) {
            host.appendChild(form);
        }
    }

    function clearFixedState() {
        document.body.classList.remove(fixedBodyClass);
        const host = document.getElementById(hostId);
        const form = host?.querySelector("[data-perfil-search], .hero-palestrante-search");
        const shell = document.querySelector("[data-perfil-search-shell]");
        if (form && shell && !shell.querySelector("[data-perfil-search]")) {
            parkForm(shell, form);
            setSearchOffset(form);
        } else {
            lastSearchOffset = "";
            document.documentElement.style.removeProperty("--perfil-search-offset");
        }
        document.querySelectorAll("[data-perfil-search-shell].is-fixed").forEach((item) => {
            item.classList.remove("is-fixed");
            item.style.removeProperty("--perfil-search-height");
        });
        host?.remove();
    }

    function syncPerfilSearchFixed() {
        const hero = document.querySelector(".hero-palestrante-site");
        const shell = document.querySelector("[data-perfil-search-shell]");
        if (!hero || !shell || !document.body.classList.contains("page-palestrante-perfil")) {
            clearFixedState();
            return;
        }

        const form = document.querySelector("[data-perfil-search]")
            || shell.querySelector(".hero-palestrante-search")
            || document.querySelector(`#${hostId} .hero-palestrante-search`);
        if (!form) {
            clearFixedState();
            return;
        }

        const topOffset = headerHeight() + 8;
        const measureEl = shell.classList.contains("is-fixed") ? shell : form;
        const shouldFix = measureEl.getBoundingClientRect().top <= topOffset
            || hero.getBoundingClientRect().top < 0;

        setSearchOffset(form);

        if (!shouldFix) {
            parkForm(shell, form);
            shell.classList.remove("is-fixed");
            document.body.classList.remove(fixedBodyClass);
            shell.style.removeProperty("--perfil-search-height");
            document.getElementById(hostId)?.remove();
            return;
        }

        if (!shell.classList.contains("is-fixed")) {
            shell.style.setProperty("--perfil-search-height", `${Math.max(shell.offsetHeight, form.offsetHeight)}px`);
            shell.classList.add("is-fixed");
        }
        liftForm(form);
        document.body.classList.add(fixedBodyClass);
    }

    function onScrollOrResize() {
        if (ticking) {
            return;
        }
        ticking = true;
        window.requestAnimationFrame(() => {
            ticking = false;
            syncPerfilSearchFixed();
        });
    }

    function bindWheelBoundary(el) {
        if (!(el instanceof HTMLElement) || el.dataset.wheelPassBound === "true") {
            return;
        }
        el.dataset.wheelPassBound = "true";
        el.style.overscrollBehaviorY = "contain";
        el.addEventListener("wheel", (event) => {
            const delta = event.deltaY;
            if (!delta) {
                return;
            }

            const canScroll = el.scrollHeight > el.clientHeight + 1;
            if (!canScroll) {
                event.preventDefault();
                return;
            }

            const atTop = el.scrollTop <= 0;
            const atBottom = el.scrollTop + el.clientHeight >= el.scrollHeight - 1;
            if ((delta < 0 && atTop) || (delta > 0 && atBottom)) {
                event.preventDefault();
            }
        }, { passive: false });
    }

    function bindScrollBoundaries() {
        if (!document.body.classList.contains("page-palestrante-perfil")) {
            return;
        }
        document.querySelectorAll(scrollBoxSelector).forEach(bindWheelBoundary);
    }

    function bindPerfilSearch() {
        disposeSearch();
        clearFixedState();
        if (!document.body.classList.contains("page-palestrante-perfil")) {
            return;
        }
        if (document.documentElement.dataset.perfilSearchBound !== "true") {
            document.documentElement.dataset.perfilSearchBound = "true";
            window.addEventListener("scroll", onScrollOrResize, { passive: true });
            window.addEventListener("resize", onScrollOrResize);
        }
        syncPerfilSearchFixed();
        bindScrollBoundaries();
        const form = document.querySelector("[data-perfil-search]");
        if (form) bindInlineSearch(form);
    }

    window.siteReady(() => {
        bindPerfilSearch();
    });
})();
